export enum TimeFormat {
	TWELVE = 'hh:mm a',
	TWENTY_FOUR = 'HH:mm'
}
